export default "__VITE_ASSET__9c92b909__"